import {
  Spaceable
} from "./chunk.G3SZKTQJ.js";
import {
  setLink
} from "./chunk.ABOYTYJO.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ChangesBackgroundColor
} from "./chunk.7ANACPIR.js";
import {
  D,
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  e,
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-audio-player/jb-audio-player.scss?inline
var jb_audio_player_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
h4, p {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

p {
  color: rgb(var(--rgb-primary, 20, 30, 85));
  font-size: 1.063rem;
  line-height: 1.875rem;
}
@media (min-width: 1281px) {
  p {
    font-size: 1.188rem;
    line-height: 2.125rem;
  }
}

h4 {
  color: rgb(var(--rgb-primary, 20, 30, 85));
  font-size: 1.375rem;
  line-height: 1.75rem;
}
@media (min-width: 1281px) {
  h4 {
    font-size: 1.75rem;
    line-height: 2.5rem;
  }
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  display: block;
}

.description {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
}
@media (min-width: 1281px) {
  .description {
    flex-wrap: nowrap;
    justify-content: center;
    margin-block: 0;
    margin-block-end: var(--spacing-sm);
  }
}

.links {
  gap: var(--spacing-l);
  margin-block-end: var(--spacing-sm);
}
@media (min-width: 1281px) {
  .links {
    gap: var(--spacing-sm);
    margin: 0;
  }
}

.links a {
  height: 24px;
}

section {
  border: 1px solid #141e55;
  padding: 40px 30px;
  position: relative;
}
@media print {
  section {
    display: none;
  }
}

h4 {
  flex-basis: 100%;
  margin-block-end: var(--spacing-xs);
}

p {
  flex-basis: 100%;
  margin-block-end: var(--spacing-sm);
}
@media (min-width: 1281px) {
  p {
    margin: 0;
  }
}

div {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

jb-play-pause-button {
  margin-right: 18px;
}

jb-timer {
  flex-shrink: 0;
  margin-left: 7px;
  transform: translateY(-1px);
  width: 54px;
}

input[type=range] {
  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  cursor: pointer;
  width: 100%;
}

input[type=range]::-moz-range-thumb {
  appearance: none;
  background-color: #141e55;
  height: 20px;
  width: 4px;
}

input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  background-color: #141e55;
  height: 20px;
  transform: translateY(-9px);
  width: 4px;
}

jb-listing-item {
  display: block;
  padding-top: var(--spacing-sm);
}

/***** Chrome, Safari, Opera, and Edge Chromium *****/
input[type=range]::-webkit-slider-runnable-track {
  background: rgba(20, 30, 85, 0.2);
  height: 2px;
}

/******** Firefox ********/
input[type=range]::-moz-range-track {
  background: rgba(20, 30, 85, 0.2);
  height: 2px;
}`;

// src/components/jb-audio-player/jb-audio-player.ts
var JbAudioPlayer = class extends ChangesBackgroundColor(Spaceable(h)) {
  constructor() {
    super(...arguments);
    this.ariaLabelPause = "";
    this.ariaLabelPlay = "";
    this.headline = "";
    this.intersectionObserver = new IntersectionObserver((entries) => {
      if (entries[0].intersectionRatio <= 0) return;
      this.intersectionObserver.unobserve(this);
      this.dispatchEvent(
        new CustomEvent("jb-tracking", {
          detail: {
            event: "ce_audio",
            event_version: "v2",
            component_name: "audio-player",
            file_name: this.src.split("/").pop(),
            file_progress: "visible",
            file_type: this.src.split(".").pop()?.toLocaleLowerCase()
          },
          bubbles: true,
          composed: true
        })
      );
    });
    this.spriteSvgUrl = "";
    this._progress = 0;
  }
  update(changedProperties) {
    super.update(changedProperties);
    if (changedProperties.has("duration")) {
      this._updateRemainingTime();
    }
  }
  async firstUpdated() {
    document.addEventListener("keydown", (e2) => {
      if (e2.code === "KeyM") {
        this._audioElement.muted = !this._audioElement.muted;
      }
      if (e2.code === "ArrowUp") {
        this._audioElement.volume = Math.min(1, this._audioElement.volume + 0.1);
      }
      if (e2.code === "ArrowDown") {
        this._audioElement.volume = Math.max(0, this._audioElement.volume - 0.1);
      }
    });
    this._playPauseButton.setMediaElement(this._audioElement);
    this._boundDispatchStartEvent = this._dispatchStartEvent.bind(this);
    this._audioElement.addEventListener("play", this._boundDispatchStartEvent);
    this.intersectionObserver.observe(this);
  }
  _dispatchPercentageEvent() {
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_audio",
          event_version: "v2",
          component_name: "audio-player",
          file_name: this.src.split("/").pop(),
          file_progress: this._progress + "%",
          file_type: this.src.split(".").pop()?.toLocaleLowerCase(),
          time_elapsed: Math.round(this.duration / 100 * this._progress)
        },
        bubbles: true,
        composed: true
      })
    );
  }
  _dispatchStartEvent() {
    this._audioElement.removeEventListener("play", this._boundDispatchStartEvent);
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_audio",
          event_version: "v2",
          component_name: "audio-player",
          file_name: this.src.split("/").pop(),
          file_progress: "start",
          file_type: this.src.split(".").pop()?.toLocaleLowerCase()
        },
        bubbles: true,
        composed: true
      })
    );
  }
  _downloadClick(event) {
    event.stopPropagation();
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_download",
          event_version: "v2",
          component_name: "listing",
          file_name: this.src.split("/").pop(),
          file_type: this.src.split(".").pop()?.toLowerCase()
        },
        bubbles: true,
        composed: true
      })
    );
  }
  _getContentSpacingProperties() {
    if (this.noVerticalSpace) {
      return { type: "no-vertical-space" };
    }
    return { type: "media" };
  }
  _handleSeekInput() {
    this._audioElement.currentTime = parseInt(this._seek.value, 10);
  }
  _initializeAudioMetaData() {
    this.duration = Math.round(this._audioElement.duration);
  }
  _setPodcastLink(link, icon, ariaLabel) {
    const anchor = document.createElement("a");
    setLink(anchor, link);
    anchor.innerHTML = icon;
    anchor.setAttribute("aria-label", ariaLabel);
    anchor.setAttribute("title", ariaLabel);
    return anchor;
  }
  _updateRemainingTime() {
    const currentTime = this._audioElement?.currentTime || 0;
    this._seek.value = Math.round(currentTime).toString();
    this._timer.seconds = -((this.duration || 0) - currentTime);
    const currentPercentagePlayed = this.duration > 0 ? Math.round(currentTime / this.duration * 10) * 10 : 0;
    if (currentPercentagePlayed > this._progress) {
      this._progress = currentPercentagePlayed;
      this._dispatchPercentageEvent();
    }
  }
  render() {
    return ke`
      <section>
        ${this.headline ? ke`<h4>${this.headline}</h4>` : D}
        <div class="description">
          ${this.description ? ke`<p>${this.description}</p>` : D}
          ${this.spotifyPodcastLink?.href || this.applePodcastLink?.href ? ke`
                <div class="links">
                  ${this.spotifyPodcastLink?.href ? this._setPodcastLink(this.spotifyPodcastLink, "<jb-spotify-icon>", this.ariaLabelSpotifyPodcast) : D}
                  ${this.applePodcastLink?.href ? this._setPodcastLink(this.applePodcastLink, "<jb-apple-podcast-icon>", this.ariaLabelApplePodcast) : D}
                </div>
              ` : D}
        </div>

        <div>
          <jb-play-pause-button
            .ariaLabelPause=${this.ariaLabelPause}
            .ariaLabelPlay=${this.ariaLabelPlay}
            .spriteSvgUrl=${this.spriteSvgUrl}
          ></jb-play-pause-button>
          <input
            aria-label="${this.ariaLabelSeek ?? "Seek"}"
            @input=${this._handleSeekInput}
            type="range"
            min="0"
            value="0"
            max="${Math.round(this.duration)}"
          />
          <jb-timer
            .align=${"right"}
            .seconds=${this.duration}
          ></jb-timer>
        </div>
        <audio
          @timeupdate=${this._updateRemainingTime}
          @loadedmetadata=${this._initializeAudioMetaData}
          preload="metadata"
        >
          <source
            src="${this.src}"
            type="${this.mimeType}"
          />
        </audio>
        ${this.downloadText ? ke`
              <jb-listing-item
                .file=${{ size: this.fileSize || "", type: this.fileType || "" }}
                .link=${{
      href: this.src,
      data: { type: "download", downloadFileName: this.src.split("/").pop() || "" }
    }}
                .type=${"download"}
                .text=${this.downloadText}
                @jb-link:clicked=${this._downloadClick}
              ></jb-listing-item>
            ` : D}
      </section>
    `;
  }
};
JbAudioPlayer.styles = r(jb_audio_player_default);
__decorateClass([
  n({ type: Object })
], JbAudioPlayer.prototype, "applePodcastLink", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "ariaLabelApplePodcast", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "ariaLabelPause", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "ariaLabelPlay", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "ariaLabelSeek", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "ariaLabelSpotifyPodcast", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "description", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "downloadText", 2);
__decorateClass([
  n({ type: Number })
], JbAudioPlayer.prototype, "duration", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "fileDate", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "fileId", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "fileSize", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "fileType", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "headline", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "mimeType", 2);
__decorateClass([
  n({ type: Boolean })
], JbAudioPlayer.prototype, "noVerticalSpace", 2);
__decorateClass([
  n({ type: Object })
], JbAudioPlayer.prototype, "spotifyPodcastLink", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "spriteSvgUrl", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "src", 2);
__decorateClass([
  e("audio")
], JbAudioPlayer.prototype, "_audioElement", 2);
__decorateClass([
  e("jb-play-pause-button")
], JbAudioPlayer.prototype, "_playPauseButton", 2);
__decorateClass([
  e("input")
], JbAudioPlayer.prototype, "_seek", 2);
__decorateClass([
  e("jb-timer")
], JbAudioPlayer.prototype, "_timer", 2);
JbAudioPlayer = __decorateClass([
  customElement("jb-audio-player")
], JbAudioPlayer);

export {
  JbAudioPlayer
};
